module.exports = __webpack_public_path__ + "img/icon04.2011071.png";